import { render, staticRenderFns } from "./ReportDisasterAmount.vue?vue&type=template&id=20cb4d0e&scoped=true"
import script from "./ReportDisasterAmount.vue?vue&type=script&lang=js"
export * from "./ReportDisasterAmount.vue?vue&type=script&lang=js"
import style0 from "./ReportDisasterAmount.vue?vue&type=style&index=0&id=20cb4d0e&prod&scoped=true&lang=css"
import style1 from "./ReportDisasterAmount.vue?vue&type=style&index=1&id=20cb4d0e&prod&lang=css"
import style2 from "./ReportDisasterAmount.vue?vue&type=style&index=2&id=20cb4d0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cb4d0e",
  null
  
)

export default component.exports